"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scaledStrokeWidth; // Copyright (c) 2018 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var STROKE_MAX = 4.2;
var STROKE_MIN = 2;
var STROKE_SPREAD = STROKE_MAX - STROKE_MIN;
var PROPS_MAX = {
  style: {
    strokeWidth: STROKE_MAX.toFixed(1)
  }
};
var PROPS_MIN = {
  style: {
    strokeWidth: STROKE_MIN.toFixed(1)
  }
};
var THRESHOLD_MAX = 0.1;
var THRESHOLD_MIN = 0.6;
var THRESHOLD_SPREAD = THRESHOLD_MIN - THRESHOLD_MAX;
var cache = {};
var lastK = -Number.MIN_VALUE;
var lastProps = PROPS_MIN;

function scaledStrokeWidth(graphState) {
  var _ref = graphState.zoomTransform || {},
      _ref$k = _ref.k,
      k = _ref$k === void 0 ? 1 : _ref$k;

  if (k === lastK) {
    return lastProps;
  }

  var props = lastProps;

  if (k > THRESHOLD_MIN) {
    props = PROPS_MIN;
  } else if (k < THRESHOLD_MAX) {
    props = PROPS_MAX;
  } else {
    var strokeWidth = (STROKE_MIN + STROKE_SPREAD * (THRESHOLD_MIN - k) / THRESHOLD_SPREAD).toFixed(1);
    props = cache[strokeWidth] || (cache[strokeWidth] = {
      style: {
        strokeWidth: strokeWidth
      }
    });
  }

  lastK = k;
  lastProps = props;
  return props;
}